/* Consent-aware, first-party cart diagnostic. This never sends a GA4 event. */
(() => {
  'use strict';
  const key = '__j_measurement';
  let desired;
  let lastAttempt;
  let writing = false;

  function analyticsAllowed() {
    try {
      const api = window.Shopify?.customerPrivacy;
      return api?.currentVisitorConsent?.().analytics === 'yes'
        && api.analyticsProcessingAllowed() === true;
    } catch (_) {
      return false;
    }
  }

  function endpoint() {
    const root = window.Shopify?.routes?.root;
    return (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(root || '') ? root : '/') + 'cart/update.js';
  }

  async function flush() {
    if (writing) return;
    writing = true;
    try {
      while (desired !== lastAttempt) {
        const value = desired;
        lastAttempt = value;
        try {
          // Only this key is patched. Native items, delivery and checkout remain untouched.
          await fetch(endpoint(), {
            method: 'POST', credentials: 'same-origin', keepalive: true,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { [key]: value } })
          });
        } catch (_) {
          // Best effort; no automatic retry, extra pixel, or checkout delay.
        }
      }
    } finally {
      writing = false;
    }
  }

  function enqueue(value) {
    desired = value;
    void flush();
  }

  function checkpoint() {
    if (!analyticsAllowed()) {
      // Clear a possible earlier grant; never record a refusal as analytics data.
      enqueue('');
      return;
    }
    try {
      // Read cookie names only after explicit permission. Values never leave this function.
      const names = document.cookie.split(';').map(part => part.trim().split('=', 1)[0]);
      const ga = Number(names.includes('_ga'));
      const stream = Number(names.includes('_ga_Z0WKJHJ3NK'));
      const minute = new Date().toISOString().slice(0, 16) + 'Z';
      enqueue(`v1|a1|g${ga}|s${stream}|m${minute}`);
    } catch (_) {
      // An unavailable cookie API is unknown; do not manufacture a positive marker.
      enqueue('');
    }
  }

  function ownCheckout(url) {
    try {
      const destination = new URL(url, window.location.origin);
      return destination.origin === window.location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout\/?$/i.test(destination.pathname);
    } catch (_) { return false; }
  }

  function checkoutControl(target) {
    const node = target?.closest?.('button[name="checkout"], input[name="checkout"], .kaching-cart__checkout-button, a[href]');
    if (!node || node.disabled || node.getAttribute('aria-disabled') === 'true') return false;
    // Accelerated buttons can skip the cart and do not support cart attributes.
    if (node.closest?.('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, .additional-checkout-buttons')) return false;
    if (node.matches('a[href]')) {
      return ownCheckout(node.href);
    }
    return true;
  }

  document.addEventListener('click', event => {
    if (!event.defaultPrevented && checkoutControl(event.target)) checkpoint();
  }, { capture: true, passive: true });
  document.addEventListener('submit', event => {
    if (event.defaultPrevented) return;
    if (event.submitter) {
      if (checkoutControl(event.submitter)) checkpoint();
      return;
    }
    // An implicit /cart submit can update quantities; only /checkout is unambiguous.
    const form = event.target;
    if (form?.matches?.('form[action]') && ownCheckout(form.action)) checkpoint();
  }, { capture: true, passive: true });
  document.addEventListener('visitorConsentCollected', () => {
    // Also clear a possible marker from an earlier document.
    if (!analyticsAllowed()) enqueue('');
  });
})();
